import { ArrowUpRight, BrainCircuit, Scale, ShieldCheck, WalletCards } from "lucide-react";
import { Link } from "react-router-dom";

const GROUPS = [
  {
    title: "Rights & consent",
    description: "The contractual and personal-data boundaries of HUMN.",
    icon: Scale,
    policies: [
      ["User Agreement", "Contract", "/terms"],
      ["Privacy Policy", "Personal data", "/privacy"],
      ["Cookie Policy", "Tracking", "/cookie-policy"],
    ],
  },
  {
    title: "Intelligence & safety",
    description: "How people, AI and content behave safely on-platform.",
    icon: ShieldCheck,
    policies: [
      ["HumnAi Policy", "AI authority", "/humnai-policy"],
      ["Content Policy", "Moderation", "/content-policy"],
      ["Community Guidelines", "Conduct", "/community-guidelines"],
      ["Safety Policy", "Risk", "/safety-policy"],
    ],
  },
  {
    title: "Value & fulfilment",
    description: "How Credits, creators and transaction outcomes are governed.",
    icon: WalletCards,
    policies: [
      ["Credits Policy", "Value", "/credits-policy"],
      ["Creator Policy", "Supply", "/creator-policy"],
      ["Refund Policy", "Resolution", "/refund-policy"],
    ],
  },
];

export const CrossPolicyMap = () => (
  <section className="cross-policy-map" aria-labelledby="cross-policy-map-title" data-testid="cross-policy-map">
    <div className="cross-policy-map-heading">
      <p className="eyebrow">Governance architecture</p>
      <h2 id="cross-policy-map-title" data-testid="cross-policy-map-title">One master framework.<br />Ten operating layers.</h2>
      <p data-testid="cross-policy-map-description">The Master Policy sets the authority. Each supporting document governs a specific relationship within HUMN.</p>
    </div>

    <div className="cross-policy-canvas">
      <div className="cross-policy-master" data-testid="cross-policy-master-node">
        <BrainCircuit size={22} aria-hidden="true" />
        <span><small>Governing hub</small><strong>Master<br />Governance</strong></span>
      </div>

      <div className="cross-policy-groups">
        {GROUPS.map(({ title, description, icon: Icon, policies }, groupIndex) => (
          <div className="cross-policy-branch" key={title} data-testid={`cross-policy-group-${groupIndex + 1}`}>
            <div className="cross-policy-group-label">
              <Icon size={18} aria-hidden="true" />
              <span><strong>{title}</strong><small>{description}</small></span>
            </div>
            <div className="cross-policy-nodes">
              {policies.map(([name, relation, path]) => (
                <Link to={path} key={path} data-testid={`cross-policy-link-${path.slice(1)}`}>
                  <span><small>{relation}</small><strong>{name}</strong></span>
                  <ArrowUpRight size={15} aria-hidden="true" />
                </Link>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);